import type { TRuleWithTheme } from '@/styles/theme';

export const members: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
});
